export default __webpack_public_path__ + "static/media/dog.b8fc1c43.png";